<template>
  <panel class="messages" title="Powiadomienia">
    <button slot="toolbar" aria-label="Zamknij listę powiadomień" class="btn btn-sm btn-icon" @click="$emit('close')">
      <i class="fal fa-fw fa-times" />
    </button>

    <div class="messages-list">
      <list-item
        v-for="(message, index) of messages"
        :key="'message_' + index"
        :message="message"
        @read="markAsRead"
        @view="goToDetails"
      />

      <span v-if="messages.length === 0" class="text-muted-light">Brak nowych powiadomień</span>
    </div>

    <div slot="footer">
      <w-button class="btn-sm float-left messages-btn" text="Przeczytano wszystkie" @click="markAllAsRead" />

      <w-button class="btn-sm float-right messages-btn" text="Pokaż wszystkie" @click="showAll" />
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import ListItem from './ListItem';

// @vuese
// Lista powiadomień
// @group messages
export default {
  components: { Panel, ListItem },
  computed: {
    ...mapState({
      messages: state => state.systemMessage.unreadList
    })
  },
  methods: {
    // @vuese
    // Pokaż pełne powiadomienie
    goToDetails(id) {
      this.$router.push({ name: 'systemMessage', params: { messageId: id } });
      this.markAsRead(id);
    },

    // @vuese
    // Oznacz jako odczytane
    markAsRead(id) {
      return this.$store.dispatch('systemMessage/read', id);
    },

    // @vuese
    // Pokaż wszystkie powiadomienia
    showAll() {
      this.$router.push({ name: 'systemMessageList' });
    },

    // @vuese
    // Oznacz wszystkie jako przeczytane
    markAllAsRead() {
      Promise.all(this.messages.map(message => this.markAsRead(message.id)));
    }
  }
};
</script>

<style>
.messages {
  width: 350px;
  left: -230px;
  z-index: 10;
}

.messages-list {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
